import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { FormBulkSchedulingPrePlanting } from "./step/FormBulkSchedulingPrePlanting.jsx"
import { BulkPreviewPrePlanting } from "./step/BulkPreviewPrePlanting.jsx"
import { useSubheader } from "../../../../../../_metronic/layout/index.js"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { SavedGlobalListScheduleOrder } from "../../../../../../redux/actions/OrderAction.jsx"
import { ROUTING_STATUS } from "../../../../../../constants/StringConstant.js"
import * as Yup from "yup"
import { FORM_NEED, getStringErrorMassage } from "../../../../../helpers/StringCollection.js"
import { TabsInputComponent } from "../../../../../../component/index.jsx"

export function PrePlantingBulkApprove({
  match: {
    params: { planting }
  }
}) {
  const { Order } = useSelector((state) => state)
  const history = useHistory()
  const { t } = useTranslation()
  const [stepTitle] = useState([t("label_spraying_schedule"), t("label_preview")])
  const [stepDesc] = useState([
    t("label_spraying_activity_scheduling"),
    t("label_review_and_submit")
  ])

  const [dataApprovalBulk, setDataApprovalBulk] = useState(undefined)
  const [listSelected, setListSelected] = useState(undefined)
  const [dataTeamSelected, setDataTeamSelected] = useState(undefined)
  const [initialValue] = useState({
    team_id: "",
    spraying_date_list: [],
    rejection_enum_list: [],
    rejection_reason: ""
  })

  const formBulk = [
    <FormBulkSchedulingPrePlanting
      key={1}
      dataTeamSelected={(e) => setDataTeamSelected(e)}
      listSelected={changeListSelected}
      data={dataApprovalBulk}
      dataListSelected={dataTeamSelected}
      planting={planting}
    />,
    <BulkPreviewPrePlanting
      key={2}
      dataTeamSelected={dataTeamSelected}
      listSelectedDate={listSelected}
      data={dataApprovalBulk}
      planting={planting}
    />
  ]

  const formRef = useRef()
  const subheader = useSubheader()

  function changeListSelected(e) {
    setListSelected(e)
  }

  const breadcrumbData = [
    {
      pathname: RoutesConstants.ORDER.LIST_PRE_PLANTING_BY_STATUS(
        ROUTING_STATUS.SPRAYING_PASCA_PLANTING_STRING.PENDING
      ),
      title: t("label_scheduling")
    },
    {
      pathname: RoutesConstants.ORDER.LIST_PRE_PLANTING_BY_STATUS(
        ROUTING_STATUS.SPRAYING_PASCA_PLANTING_STRING.PENDING
      ),
      title: t("sub_header_pre_planting")
    },
    {
      pathname: RoutesConstants.ORDER.LIST_PRE_PLANTING_BY_STATUS(
        ROUTING_STATUS.SPRAYING_PASCA_PLANTING_STRING.PENDING
      ),
      title: t("menu_aside_pending")
    },
    {
      title: t("label_bulk_approval")
    }
  ]

  const dispatch = useDispatch()
  useEffect(() => {
    if (Order.listDataInitFormApproveBulk) {
      if (Order.listDataInitFormApproveBulk.length === 0) {
        dispatch(SavedGlobalListScheduleOrder([]))
        history.push(
          RoutesConstants.ORDER.LIST_PRE_PLANTING_BY_STATUS(
            ROUTING_STATUS.SPRAYING_PASCA_PLANTING_STRING.PENDING
          )
        )
      } else {
        setDataApprovalBulk(Order.listDataInitFormApproveBulk)
      }
    } else {
      dispatch(SavedGlobalListScheduleOrder([]))
      history.push(
        RoutesConstants.ORDER.LIST_PRE_PLANTING_BY_STATUS(
          ROUTING_STATUS.SPRAYING_PASCA_PLANTING_STRING.PENDING
        )
      )
    }
  }, [Order])

  useEffect(() => {
    subheader.setBreadcrumbs(breadcrumbData)
  }, [])

  function onSubmitBulk() {
    // alert("submit");
  }

  const validationSchema = [
    Yup.object().shape({
      team_id: Yup.string().required(getStringErrorMassage("Tim Drone", FORM_NEED.harusDiIsi))
    })
  ]

  return (
    <>
      {dataApprovalBulk && (
        <TabsInputComponent
          isEditTabs={false}
          formId="form_bulk"
          steps={stepTitle}
          stepDescription={stepDesc}
          formInitialValues={initialValue}
          validationSchema={validationSchema}
          innerRef={formRef}
          componentTab={formBulk}
          onSubmitForm={onSubmitBulk}
        />
      )}
    </>
  )
}